import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

import { PencilIcon } from "components/icons";
import TruncateText from "components/TruncateText";

import { capitalizeFirstLetter } from "helpers/capitalizeFirstLetter";
import cn from "lib/cn";

import { TTabeField, TTableRecord } from "../../types";

export interface FieldTextEditableProps {
  field?: TTabeField;
  record?: TTableRecord;
}

const FieldTextEditable = ({ field, record }: FieldTextEditableProps) => {
  const value = useMemo(() => {
    let val = field?.key ? record?.[field.key] : "";

    if (!field?.key || field.staticValue) {
      val = field?.staticValue || "";
    }

    if (field?.capitalizeText && val) {
      val = capitalizeFirstLetter(val);
    }

    return val;
  }, [record, field]);

  const handleClick = () => {
    if (field?.onClick) {
      field.onClick(record);
    }
  };

  return (
    <div
      className={cn([
        "text-neutral-gray-900 flex gap-3 items-center",
        field?.className,
      ])}
    >
      <div className={cn("w-full", field?.wrapperClassName)}>
        <button
          onClick={handleClick}
          className="w-full rounded-sm border boreder-line-500 px-[0.3rem] flex items-center justify-between"
        >
          <TruncateText
            id={uuidv4()}
            className="flex"
            text={!value ? "-" : value}
            tooltipWidth={value?.length > 70 ? "18.75rem" : "auto"}
          />

          <PencilIcon width={12} height={12} viewBox="0 0 20 20" />
        </button>
      </div>
    </div>
  );
};

export default FieldTextEditable;
